var map = {
	"./aiAnswer-default-light.png": "b87d",
	"./aiAsk-default-light.png": "d521",
	"./aiWatching-default-light.png": "58c7",
	"./police-default-light.png": "1b69",
	"./thousand-default-light.png": "b56f",
	"./video-default-light.png": "7544"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b34";